import {TabComponent} from "./tab.component";
import {DynamicTabHolderComponent} from "./tab-holder.component";

export const BO_TAB_COMPONENTS = [
    TabComponent,
    DynamicTabHolderComponent
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/bo-tabs/index.ts